import BindLocalAccountPopupContent from './components/BindLocalAccountPopupContent';
import BindLocalAccountPopupFooter from './components/BindLocalAccountPopupFooter';
import { DefaultContentComponent, DefaultFooterComponent } from '@silverfort/sf-components';

export const BIND_POPUP_CONFIG = {
    title: 'Edit bound entity',
    popupClassName: 'w-[544px] h-[488px]',
    contentClassName: 'py-0 px-3',
    ContentComponent: BindLocalAccountPopupContent,
    FooterComponent: BindLocalAccountPopupFooter
};

export const UNBIND_POPUP_CONFIG = {
    title: 'Unbind AD accounts',
    ContentComponent: DefaultContentComponent,
    FooterComponent: DefaultFooterComponent,
    ContentComponentProps: {
        text: 'Are you sure you want to unbind the AD accounts?'
    },
    FooterComponentProps: {
        primaryButtonProps: {
            text: 'Unbind'
        }
    }
};
